import * as XLSX from 'xlsx';
import { formatPhoneNumber } from '../../../helpers/formatPhoneNumber';

const daysOfWeek = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
const CALL_DIRECTIONS = {
  in: 'вх.',
  out: 'исх.',
  callback: 'callback',
};

export const exportToExcel = (calls) => {
  const data = calls.map((call) => {
    const date = new Date(call.createTime);

    const direction = call?.direction ? CALL_DIRECTIONS[call?.direction] : '-';

    const dayIndex = (date.getDay() + 6) % 7;

    const phoneNumber = call?.callerId
      ? formatPhoneNumber({
          phoneNumber: String(call?.callerId),
        })
      : '-';

    const redirectPhoneNumber = call?.redirectPhone
      ? formatPhoneNumber({
          phoneNumber: String(call?.redirectPhone),
        })
      : '-';

    return {
      'День недели': daysOfWeek[dayIndex],
      Дата: date.toLocaleDateString('ru-RU'),
      Время: date.toLocaleTimeString('ru-RU'),
      УК: call?.serviceCompany || '-',
      Направление: direction,
      Номер: phoneNumber,
      'Время ожидания': call?.waitingTime || '-',
      'Чистое время ожидания': call?.clearWaitingTime || '-',
      'Время разговора': call?.talkTime || '-',
      Заявки: call?.requests || '-',
      Оператор: call?.operator?.shortName || '-',
      'УК оператора': call?.operator?.serviceCompany?.name || '-',
      Переадресация: redirectPhoneNumber,
      Аварийный: call?.isAlert ? 'Да' : 'Нет',
    };
  });

  const numCols = 14;
  const width = 20;

  const worksheet = XLSX.utils.json_to_sheet(data);
  worksheet['!cols'] = Array.from({ length: numCols }, () => ({ wch: width }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'История звонков');

  XLSX.writeFile(workbook, 'История звонков.xlsx');
};
